import { useMsal } from '@azure/msal-react';
import './signInButton.css';

export default function SignInButton() {
    const { instance } = useMsal();

    const handleLogin = () => {
        instance.loginRedirect();
    };    

    return <button className="sign-in-button" onClick={handleLogin}>Sign In</button>;
}